import { ref } from 'vue';
import { apiLink } from './apiLink'
import {getData, deleteData, postData, putData, putDataRaw, patchData, patchDataRaw} from './generalio'

const dbProjectReadWrite = () => {
    const projectInfo = ref([])
    const errorproj = ref(null)
    var type=''
    var hostroot = apiLink
    var endpoint = "/project"
    const loadCompanies = () => {

        let newEndpoint = 'company'
        return getData(newEndpoint, "company")
        .catch(err => {
            throw Error ('error getting company list from the database:' + err)
        })

    }
    const vetPickListValues = (genInfo, inproperty, outproperty) => {
        
        for (var property in genInfo) {
            console.log('property:'+property)
            if(inproperty != null && inproperty == property) {
                if (outproperty != null) {
                    newProperty = outproperty
                } else {
                    newProperty = inproperty + '__PL'
                }
                genInfo[newProperty] = "converted-" + genInfo[property]
            } else if (property.endsWith('Id')) {
                var newProperty = property.substring(0,property.length-2) + "__PL"
                console.log('newProperty:'+newProperty)
                genInfo[newProperty] = "converted-" + genInfo[property]
            }
            
        }
        
    }
    const loadDataProj = async (project) => {
        //This doesn't use 'type' - it just gets all the info for general, sellrates and expenses

        let newEndPoint = `project/${project}`
        return getData(newEndPoint, "project")
        .catch(err => {
            errorproj.value = err.message
            console.log('error fetching project general data: ', errorproj.value)
        })

      
    }
    
    const loadDataProjListNew = () => {
        let url = apiLink + '/project'
        console.log('fetch from abcd ',url)
        return getData('project','load project list abc',[])
        .then(response => {
                console.log("we have returned from the general function in  loadDataProjListNew", response)
                projectInfo.value = response;
                return response;
            }).catch(err => {
                let msg = `ERROR fn: loadDataProjListNew: ${err}`
                console.log(msg)
                throw Error (msg)
            })
       
        
    }
   
    const loadDataProjList = () => {
        //This doesn't use 'type' - it just gets all the info for general, sellrates and expenses
        let status = 0
        let dataout = {}
        let dataoutt = {}
        dataoutt.data = {}
        let datavalues = null
        //try {
            
            console.log(hostroot + '/project' , 'abc')
    
            return getData('project','all projects',[])
            .then(response => {
                console.log("we have returned from the general function loadDataProjList", response)
                projectInfo.value = response;
                return response;
            }).catch(err => {
                let msg = `ERROR fn: loadLabourCostRates: ${err}`
                console.log(msg)
                throw Error (msg)
            })

    }
    const updateEntryProj = async (row, typee='') => {
        let status = 0
        let dataout = {}
        let dataoutt = {}
        dataoutt.data = {}
        let newEndPoint = `project/${row.id}/${typee}`
        let datavalues = null

        if (typee && typee.substring(0,1)!='/')
            typee = '/' + typee

        if (!type)
            type = typee

        console.log('row' + JSON.stringify(row))
        if(row.id === ''){
            return
            createEntry(row)
            return
        }
        
        let oldEntry = await getEntryProj(row.id)
        oldEntry = oldEntry[0]
        for (const property in row) {
            oldEntry[property] = row[property]
        }

        console.log('about to modify database project-general entry: ', oldEntry)

        return putDataRaw(newEndPoint, oldEntry, "project")
        .then(async res => {
            datavalues = await res.json()
            status = res.status
            dataoutt = res

            dataout.status = status
            dataout.data = dataoutt
            dataout.datavalues = datavalues
        })
        .catch(err => {
            errorproj.value = err.message
            
            if (!dataout.data){
                dataout.data = {}
            }
            dataout.data.message = 'error PUTing project data: ', errorproj.value
            console.log(dataout.data.message)
        })
        .then(res => {
            console.log(dataout, "###")
            return dataout
        })

        
    }
    
    const getEntryProj = async (rowid) => {

        let newEndPoint = `project/${rowid}`
        return getData(newEndPoint, "project")
        .catch(err=> {
            errorproj.value = err.message
            console.log('error fetching data: ', errorproj.value)
        })

    }
    
    const createEntryProj = async (row, project) => {
        //console.log('creating new entry') 
        
        
        console.log("create")
        var row1 = JSON.parse(JSON.stringify(row));
        console.log("row"+JSON.stringify(row1))
        delete row1['id'] //we have to remove ID as the insert into EF/SQL counts on this NOT being here.

        console.log(JSON.stringify(row1))

        let newEndPoint = `project/${project}/${type}`
        return postData(newEndPoint, row1, "project")
        .catch(err => {
            errorproj.value = err.message
            console.log('error fetching data: ', errorproj.value)
        })

     }


// Not used anywhere, this is deprecated?
    const deleteEntryProj = async (rowid, project) => {
        let status = 0
        let dataout = {}
        let dataoutt = null
        let datavalues = null

        let newEndPoint = `project/${project}/${rowid}`
        return deleteData(newEndPoint, "project")
        .then(async res => {
            datavalues = await res.json()
            status = res.status
            dataoutt = res

            dataout.status = status
            dataout.data = dataoutt
            dataout.datavalues = datavalues
        })
        .catch(err => {
            errorproj.value = err.message
            console.log('error fetching data: ', errorproj.value)
        })
        .then(res => {
            console.log(dataout, "###")
            return dataout
        })

    }


    const deleteEntryPromise = (id) => {
        let url = hostroot + endpoint + '/' + id;
        console.log('delete url',url)

        let newEndPoint = `project/${id}`

        return deleteData(newEndPoint, "project")
        .catch(err => {
            console.log(err)
            throw Error(err)
        })

    }


    const copyProjectPromise = (id, newname) => {
        if (newname.weekName == "" || newname.weekName == undefined) {
            newname.weekName = "Week 1"
        }
        let url = hostroot + '/duplicate/newProjectCopy/' + id + '/true/all/'+newname.projectName+'/'+newname.weekName;
        console.log('copyProjectPromise url',url)

        let newEndPoint = `duplicate/newProjectCopy/${id}/true/all/${newname.projectName}/${newname.weekName}`

        return patchDataRaw(newEndPoint, null, "project")
        .then(response => {
            console.log("one",response)
            if (response.status==200) {
                console.log("two",response)
                let reply = response.json()
                console.log("two2",reply)
                return reply
            } else {
                console.log("three",response)
                try { 
                    console.log(response)
                    response.json().then(json=> {console.log('json response:',json)}
                    ) .catch(err=>{console.log('bruh:',err)})
                } catch{
                }

                
                throw Error("CopyProject of the project didnt work for id:" + id)
            }
        }).catch(err => {
            console.log(err)
            throw Error(err)
        })
    }
    const loadLabourCheckMark = (projectId) => {
        let newEndpoint = 'project/' + projectId + '/labourratecheckmark'
        return getData(newEndpoint, 'labourCheckMark', null)
    }

    const loadLabourComment = (projectId) => {
        let newEndpoint = 'project/' + projectId + '/labourratecomment'
        return getData(newEndpoint, 'labourRateComment', null)
    }
    
    const putLabourCheckMark = (projectId, val) => {
        let newEndPoint = 'project/' + projectId + '/' + val + '/labourrate'
        return putData(newEndPoint, null, 'labourCheckMark', null)
    }

    const putLabourComment = (projectId, val) => {
        let newEndPoint = 'project/' + projectId + '/' + val + '/labourratecomment'
        return putData(newEndPoint, null, 'labourCheckMark', null)
    }
    //we are exporting overrideTableConfig in case it can be used elsewhere
    return { loadCompanies, projectInfo, errorproj, loadDataProj, loadDataProjList, loadDataProjListNew, updateEntryProj, getEntryProj, createEntryProj, deleteEntryProj,copyProjectPromise, deleteEntryPromise, vetPickListValues, loadLabourCheckMark, putLabourCheckMark, loadLabourComment, putLabourComment}
}

export default dbProjectReadWrite
